<template>
  <div>
    <press-conference-header></press-conference-header>
    <div class="header-separator"></div>

    <div style="background-color: rgba(255, 255, 255, 0.9); margin-top: 200px">
      <v-container class="site-padding">
        <v-layout row wrap class="my-text doctors-container">
          <v-flex xs12 class="text-xs-left my-text">
            <div class="pt-4 pb-4 text-xs-center">
              <div class="doctors-container--sections-brown">
                <strong
                  >Zapraszamy do obejrzenia retransmisji konferencji inaugurującej X edycję akcji Polscy Okuliści Kontra Jaskra. Spotkanie odbyło się 3 marca 2026 r.</strong
                >
              </div>
            </div>
          </v-flex>

          <v-flex xs12 v-if="showPressConference">
            <div class="flowplayer-embed-container" style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width:100%;">         <iframe webkitAllowFullScreen mozallowfullscreen allowfullscreen src="https://ljsp.lwcdn.com/api/video/embed.jsp?id=1e5e4e8c-0166-4f1b-9f12-5430cf7d0b9c&pi=6ccbd9c0-a038-4243-b85b-cdfa19dd5c05" title="0" byline="0" portrait="0" frameborder="0" allow="autoplay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>       </div>
          </v-flex>

          <v-flex v-else xs12 class="text-xs-center">
            <div
              class="flowplayer-embed-container"
              style="
                position: relative;
                padding-bottom: 56.25%;
                height: 0;
                overflow: hidden;
                max-width: 100%;
              "
            >
              <iframe
                webkitAllowFullScreen
                mozallowfullscreen
                allowfullscreen
                src="https://player.vimeo.com/video/1170679662?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                title="0"
                byline="0"
                portrait="0"
                frameborder="0"
                allow="autoplay"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import PressConferenceHeader from "@/components/partials/PressConferenceHeader";
import MyButton from "@/components/partials/Button";
import moment from "moment";
import PressConferenceNavigation from "./partials/PressConferenceNavigation";

export default {
  data() {
    return {
      startTransmission: "2026-03-03 10:15:00",
      endTransmission: "2026-03-03 18:00:00",
    };
  },
  components: {
    PressConferenceHeader,
    PressConferenceNavigation,
    MyButton,
    moment,
  },
  computed: {
    showPressConference() {
      return (
        moment().isAfter(this.startTransmission) &&
        moment().isBefore(this.endTransmission)
      );
    },
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.term-container--position {
  align-items: baseline !important;
}

.header-separator {
  background-color: transparent;
  height: 0.1px;

  @media only screen and (min-width: 960px) {
    height: 0.1px;
  }
}
.message {
  background: #ab2929;
  color: white;
  font-weight: bold;
  width: 100%;
  text-align: center;

  /* height: 50px; */
  padding: 60px 0;
  /* margin-left: 30px; */
  margin: 60px 0;
  font-size: 1.8rem;
}

.navigation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: end;
  align-items: end;
}

.navigation-container--position {
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  border-bottom: 5px solid #fff;
}

.banner {
  background-color: transparent;
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

.banner .text-container {
  font-family: "Fira Sans", sans-serif;
  text-align: left;
  color: #aaa;
  display: flex;
  vertical-align: middle;
  flex-direction: row;
  align-items: center;
}

.banner img {
  float: left;
}

.time-container {
  display: inline-flex;
  width: 100%;
}

.time-container--separator {
  width: 145px;
  padding-right: 5px;
}

.doctors-container--inputs {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
}

.doctors-container--header {
  font-size: 26px;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  color: #a41611;
  text-transform: uppercase;
}

.doctors-container--links {
  color: #a41611;
  font-family: "Fira Sans", sans-serif;
}

.doctors-container--sections {
  color: #275271;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}

.doctors-container--sections-brown {
  color: #a41611;
}

.doctors-container--sections-slim {
  color: #000;
  font-weight: 500;
  text-transform: lowercase;
}

.doctors-container--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  line-height: 120px;
  border: none;
  padding: 20px;
}

.doctors-container--icons-brown {
  background: #a82824;
}

.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}

.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}

.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}

.register-bg {
  position: relative;
}

.register-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: fixed;
  opacity: 0.1;
  background-image: url("./../assets/images/register-bg.png");
  background-repeat: repeat;
  background-position: center center;
}

.doctor-header {
  background: #a82824;
  opacity: 0.9;
}

.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}

.free-main-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 12px;
}

.main-header--wgw {
  width: 125px;
}

.main-header--pto {
  width: 90px;
}

@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }

  .main-header--pto {
    width: 200px;
  }
}

.main-header--free {
  width: 280px;
}

.button-container-blue {
  background: #275271;
  opacity: 0.9;
  cursor: pointer;
}

.button-container-red {
  background: #a82824;
  opacity: 0.9;
  position: relative;
  cursor: pointer;
}

.button-container--register {
  font-family: "Fira Sans", sans-serif;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}

.doctor-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 50px;
  line-height: 50px;
  font-weight: 900;
  width: 50%;
  color: #fff;
  padding-left: 10px;
  padding-top: 20px;
  text-transform: uppercase;
}

.button-container--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}

.button-container--arrow {
  margin-right: 20px;
}

.free-main-header--margin {
  margin-top: 100px;
}

.button-container--margin {
  margin-bottom: 30px;
}

.button-container--padding {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}

.button-container--position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
}

.videoWrapper {
  position: relative;
  width: 95%;
  left: 5%;
  top: 3%;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}

.videoWrapper iframe {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

.button-container--separator {
  position: absolute;
  top: 0;
  width: 115px;
  height: 10px;
  background: #ffffff;
}

.doctors-container--download {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.doctors-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}

@media only screen and (max-width: 600px) {
  .button-container--arrow {
    width: 20px;
    margin-right: 5px;
  }

  .button-container--text {
    font-size: 26px;
  }
}

.register-form--noShadow {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.register-container--download {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.register-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}

.register-container--sections {
  color: #275271;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}

.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  width: 100%;
  left: 0;
  top: 0;
}

.videoWrapper iframe {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PressConference.vue